import {get} from 'lodash';

export default (state = {}, {supportedLanguages}: any) => {
  return {
    ...state,
    supportedLanguages: {
      ...get(state, 'supportedLanguages', {}),
      data: supportedLanguages?.languageList || supportedLanguages || [],
    },
  };
};
